// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"a30baf04","169":"24c5051d","184":"a6ee618f","363":"96e13baf","453":"c509ba88","532":"9c2d1920","570":"4ee7f6ce","610":"e1a468c4","652":"fec7ab61","720":"7c458355","733":"67af6639","848":"0ba5b208","894":"96b812de","918":"d32edef2"}[chunkId] + ".chunk.js";
};